<template>
  <div class="examineBox">
    <div class="containter" v-loading='loading'>
      <div class="listBox">
        <div style="display:flex;align-items:center;flex-wrap:wrap;padding:0 10px">
          <div class="batchBox mb-10">
            <div :class="['batchDelete',batchIndex==1?'active':'']" style="margin-left:0" @click="signEvent">发票标记</div>
            <el-tooltip effect="dark" content="出纳短信提醒业务人员拿发票" placement="top-start">
              <div :class="['batchDelete',batchIndex==2?'active':'']" style="margin-left:0" @click="reminderEvent">短信提醒</div>
            </el-tooltip>
          </div>

          <el-select class="input mb-10" v-model="company" style="width:180px" size='mini' filterable placeholder="签约公司主体全称" @change="getInvoiceList(1)" clearable>
            <el-option v-for="(item,index) in signCompanyList" :key="index" :label="item.company" :value="item.company">
            </el-option>
          </el-select>
          <label class="label_name mb-10">发票状态：</label>
          <el-select class="mb-10" v-model="status" @change="getInvoiceList(1)" size="mini" placeholder="开票状态">
            <el-option v-for="(item,index) in statusListCW" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <label class="label_name mb-10">作废状态：</label>
          <el-select class="mb-10" style="width:160px" @change="getInvoiceList(1)" v-model="voided_status" size='mini' :clearable='true' filterable placeholder="请选择作废状态">
            <el-option v-for="(item,index) in voidedList" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <label class="label_name mb-10">财务审核时间：</label>
          <el-date-picker class="mb-10" @change="getInvoiceList(1)" style="width:240px" v-model="approved_date" type="daterange" value-format="yyyy-MM-dd" size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          <el-input class="mb-10" placeholder="请输入序列号" v-model.trim="serial_number" clearable @keydown.enter.native="serial_number?getInvoiceList(1):''" @clear="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="serial_number?getInvoiceList(1):''" style="padding:0 10px"></el-button>
          </el-input>
          <el-input class="mb-10" placeholder="请输入结算单序列号" v-model.trim="statements_id" clearable @keydown.enter.native="statements_id?getInvoiceList(1):''" @clear="getInvoiceList(1)" size="mini" style="width:200px;margin-left:10px;">
            <el-button slot="append" icon="el-icon-search" @click="statements_id?getInvoiceList(1):''" style="padding:0 10px"></el-button>
          </el-input>
        </div>
        <el-table class="table" style="margin-top:5px;" ref="multipleTable" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" height="calc(100vh - 204px)" 
          border @selection-change="handleSelectionChange" row-key="id">
          <el-table-column type="selection" align="center" :selectable='checkSelectable' :reserve-selection="true" width="45">
          </el-table-column>
          <el-table-column prop="id" label="序列号" align='center' width="60"></el-table-column>
          <el-table-column prop="customer_name" label="客户名称" align='center' width="100"></el-table-column>
          <el-table-column prop="invoice_amount" align='center' label="开票金额"></el-table-column>
          <el-table-column prop="applicant_time" align='center' label="申请日期"></el-table-column>
          <el-table-column prop="handler" align='center' label="申请人"></el-table-column>
          <el-table-column prop="company" align='center' label="签约公司"></el-table-column>
          <el-table-column prop="confirm_verify_at" width="96px" align='center' label="财务审核时间"></el-table-column>
          <el-table-column prop="invoiced_time" align='center' label="开票日期"></el-table-column>
          <el-table-column align='center' label="是否作废" width="70">
            <template slot-scope="scope">
              <img v-if="scope.row.is_voided==1" src="@/assets/img/voided.png" style="width:40px;height:29px;margin:auto" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="voided_inv_id" align='center' label="作废发票序列号"></el-table-column>
          <el-table-column align='center' label="作废状态">
            <template slot-scope="scope">
              <span v-if="scope.row.voided_status == 1" style="color:#EF7400">待商务审核</span>
              <span v-if="scope.row.voided_status == 2" style="color:#EF7400">待财务审核</span>
              <span v-if="scope.row.voided_status == 3" style="color:#EF7400">商务审核驳回</span>
              <span v-if="scope.row.voided_status == 4" style="color:#00BB5D">财务审核通过</span>
              <span v-if="scope.row.voided_status == 5" style="color:#d51313">财务审核驳回</span>
              <span v-if="scope.row.status == 6" style="color:#fc726d">财务发票撤销</span>
            </template>
          </el-table-column>
          <!-- <el-table-column align='center' label="状态">
                        <template slot-scope="scope">
                            <span v-if="scope.row.status == 1" style="color:#EF7400">待商务审核</span>
                            <span v-if="scope.row.status == 2" style="color:#EF7400">待财务审核</span>
                            <span v-if="scope.row.status == 3" style="color:#EF7400">商务审核驳回</span>
                            <span v-if="scope.row.status == 4" style="color:#00BB5D">财务审核通过</span>
                            <span v-if="scope.row.status == 5" style="color:#d51313">财务审核驳回</span>
                        </template>
                    </el-table-column> -->
          <el-table-column align='center' label="开票标记" width="80">
            <template slot-scope="scope">
              <span :style="scope.row.is_invoiced == 1?'color:#00BB5D':''">{{scope.row.is_invoiced==1?'已开票':'未开票'}}</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label="操作">
            <template slot-scope="scope">
              <button class="detailButton" v-if="scope.row.is_invoiced==1" style="background:#ff9b3b" @click="revokeInvoiced(scope.row)">撤销标记</button>
              <button class="detailButton" v-if="scope.row.is_invoiced!=1" @click="onClickSignRow(scope.row)">发票标记</button>
              <button class="detailButton" @click="goDetail(scope.row)">申请详情</button>
              <!-- <button class="detailButton" style="background:#fc726d" v-if="scope.row.status == 4 && scope.row.is_voided != 1 && scope.row.voided_status < 1" @click="invoice_id=scope.row.id;invoiceFlag=true">撤销发票</button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </div>
    <!-- <el-dialog title="" :visible.sync="detailFlag" width="80%" top="10vh" :close-on-click-modal='false'>
            <invoice-detail v-if="detailFlag" :id="invoice_id" @closeToast='()=>{detailFlag=false}' @updateList="getInvoiceList(page);detailFlag=false"></invoice-detail>
        </el-dialog> -->
    <el-dialog title="发票标记" :visible.sync="signFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox" v-loading='loading'>
        <div class="dialogitem">
          <label style="font-size:14px"><em style="color:red">*</em>开票日期：</label>
          <el-date-picker style="width:56%" v-model="timeDate" type="datetime" size="mini" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期" :disabled="true" class="signDate">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="signFlag=false" size="mini">取 消</el-button>
        <el-button type="primary" @click="actualInvoiced" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 撤销 -->
    <el-dialog title="撤销发票" :visible.sync="invoiceFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox" v-loading='invoiceLoading'>
        <div class="dialogitem">
          <label>撤销理由：</label>
          <el-input style="margin-top:10px;width:100%" type="textarea" :rows="2" placeholder="请输入撤销理由" v-model="verify_note">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="invoiceFlag=false;verify_note='';invoice_id=''" size="mini">取消</el-button>
        <el-button type="primary" @click="invoiceCancel()" size="mini">发票撤销</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// import invoiceDetail from './invoiceDetail'
export default {
  // components:{
  //     invoiceDetail
  // },
  data () {
    return {
      statements_id: '',
      serial_number: '',
      detailFlag: false,
      page: 1,
      page_size: 50,
      total: 0,
      loading: false,
      tab: 0,
      accountList: [],
      timeMonth: '',
      customer_name: '',
      customerList: [],
      invoice_id: '',
      multipleSelection: [],
      signFlag: false,
      timeDate: '',
      company: '',
      signCompanyList: [],
      status: 4,
      statusListCW: [
        { value: 4, label: '财务审核通过' },
        { value: 6, label: '财务发票撤销' },
      ],
      voidedList: [
        { value: 1, label: '待商务审核' },
        { value: 2, label: '待财务审核' },
        { value: 3, label: '商务审核驳回' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核驳回' },
      ],
      voided_status: '',
      approved_date: [],
      invoiceFlag: false,
      invoiceLoading: false,
      verify_note: '',
      batchIndex: 1,
    }
  },
  created () {
    this.getSignCompanyList()
    this.getInvoiceList(1)
  },
  mounted () {
  },
  methods: {
    invoiceCancel () {//财务发票撤销
      if (this.verify_note == '' || !this.verify_note) {
        this.$message({
          message: '请输入撤销理由',
          type: 'warning'
        })
        return
      }
      this.invoiceLoading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.invoiceCancel, {
        id: this.invoice_id,
        verify_note: this.verify_note
      }).then((res) => {
        this.invoiceLoading = false;
        var res = res.data;
        if (res && res.errno == 0) {
          this.invoice_id = ''
          this.verify_note = ''
          this.invoiceFlag = false
          this.getInvoiceList(this.page)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.invoiceLoading = false;
      })
    },
    revokeInvoiced (data) {//撤销标记
      this.$confirm('确定撤销此发票标记？', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.post(this.URL.BASEURL + this.URL.delActualInvoiced, {
          id: data.id,
        }).then((res) => {
          var res = res.data;
          this.loading = false;
          if (res && res.errno == 0) {
            this.getInvoiceList(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch((action) => {
      });
    },
    reminderEvent () {
      if (this.batchIndex == 1) {
        this.$refs.multipleTable.clearSelection();//清空用户选择
        this.batchIndex = 2;
        this.multipleSelection = [];
        return
      }
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择发票',
          type: 'warning'
        })
        return
      }
      this.loading = true;
      var ids_arr = [];
      this.multipleSelection.forEach((item, index) => {
        ids_arr.push(item.id)
      });
      this.$axios.post(this.URL.BASEURL + this.URL.order_reminder, {
        ids: ids_arr,
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$refs.multipleTable.clearSelection();//清空用户选择
          this.$message({
            message: '提醒成功！',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    signEvent () {
      if (this.batchIndex == 2) {
        this.$refs.multipleTable.clearSelection();//清空用户选择
        this.batchIndex = 1;
        this.multipleSelection = [];
        return
      }
      if (!this.multipleSelection || this.multipleSelection.length == 0) {
        this.$message({
          message: '未选择发票',
          type: 'warning'
        })
        return
      }
      this.signFlag = true;
      this.handleGetTime()
    },
    actualInvoiced () {
      if (this.timeDate == '') {
        this.$message({
          message: '请选择开票日期',
          type: 'warning'
        })
        return
      }
      this.loading = true;
      var ids_arr = [];
      this.multipleSelection.forEach((item, index) => {
        ids_arr.push(item.id)
      });
      this.$axios.post(this.URL.BASEURL + this.URL.actualInvoiced, {
        ids: ids_arr,
        date: this.timeDate
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.$refs.multipleTable.clearSelection();//清空用户选择
          this.getInvoiceList(this.page)
          this.signFlag = false
          this.timeDate = ''
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    checkSelectable (row) {
      if (this.batchIndex == 2) {
        return row.is_invoiced == 1 && row.is_voided != 1
      } else {
        return row.is_invoiced != 1
      }
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    goDetail (data) {
      this.invoice_id = data.id;
      let routeData = this.$router.resolve({
        path: '/invoiceCashierDetail/' + this.invoice_id,
      })
      this.$winopen(routeData.href)
    },
    handleCurrentChange (val) {
      this.getInvoiceList(val)
    },
    getInvoiceList (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.invoiceList, {
        params: {
          id: this.serial_number,
          company: this.company,
          page: page,
          pagesize: this.page_size,
          status: this.status,
          voided_status: this.voided_status,
          approved_start_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[0] : '',
          approved_end_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[1] : '',
          statements_id: this.statements_id
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSignCompanyList () {
      this.$axios.get(this.URL.BASEURL + this.URL.signCompanyList, {
        params: {
          page: 1,
          pagesize: 1000
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.signCompanyList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    handleGetTime() {
      const date = new Date();
      const year = date.getFullYear()
      const month = (date.getMonth() + 1) < 10 ? `0${date.getMonth() + 1}` : (date.getMonth() + 1)
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
      const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
      const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
      const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()
      this.timeDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    async onClickSignRow(row) {
      this.$refs.multipleTable.clearSelection();//清空用户选择
      await this.$nextTick()
      this.$refs.multipleTable.toggleRowSelection(row);
      this.handleGetTime()
      this.signFlag = true;
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-date-editor .el-range-separator {
  width: 20px;
}
.mb-10 {
  margin-bottom: 10px;
}
.signDate {
  /deep/.el-input.is-disabled .el-input__inner {
    background-color: #fff;
    color: #666;
  }
}
.label_name {
  font-size: 13px;
  margin-left: 8px;
  // line-height: 30px;
}
.examineBox {
  .containter {
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 2px 6px 0px rgba(32, 38, 82, 0.1);
    padding-top: 15px;
    margin-top: 10px;
    .topOperation {
      padding: 16px;
      .title {
        font-size: 15px;
        color: #202652;
        line-height: 21px;
        font-weight: 500;
        display: inline-block;
        vertical-align: middle;
      }
      .selectBox {
        display: inline-block;
        vertical-align: middle;
        .selectItem {
          float: left;
          font-size: 13px;
          margin-left: 20px;
          cursor: pointer;
          .icon {
            width: 13px;
            height: 13px;
            border-radius: 3px;
            border: 1px solid #d2d2d2;
            display: inline-block;
            vertical-align: bottom;
            margin-right: 3px;
          }
          &.active {
            .icon {
              border-color: #2662ff;
              position: relative;
              &::before {
                content: "";
                display: inline-block;
                width: 7px;
                height: 7px;
                background: #2662ff;
                border-radius: 1px;
                position: absolute;
                top: 2px;
                left: 2px;
              }
            }
          }
        }
      }
    }
  }
  .table {
    width: calc(100% - 30px);
    margin: 0 15px;
  }
  .detailButton {
    min-width: 60px;
    height: 22px;
    background: #5b7bfe;
    border-radius: 4px;
    color: #ffffff;
    font-size: 12px;
    border: none;
    padding: 0 3px;
  }
}
.batchBox {
  display: flex;
  align-items: center;
  margin-right: 15px;
  // margin-bottom: 15px;
  // margin: 15px 0;
  background: #ccc;
  border-radius: 4px;
  height: 28px;
  .batchDelete {
    width: 74px;
    height: 100%;
    line-height: 28px;
    font-size: 12px;
    text-align: center;
    border-radius: 4px;
    color: #fff;
    cursor: pointer;
    &.active {
      border: 1px solid #2762ff;
      background: #2762ff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/invoiceCashier.vue